module.exports = __webpack_public_path__ + "media/images/profiles/profile-1-66d0912b8582b598e23698ea6c806542.png";